import React, { useRef, useState, useCallback } from "react";
import Webcam from "react-webcam";
import AWS from "aws-sdk";
import { enrollPatientByFace } from "../../../api/apiHandler";
import Swal from "sweetalert2";
const videoConstraints = {
  width: 300,
  height: 200,
  facingMode: "user",
};

const EnroleNewPatient = ({
  handleSave,
  setPatientName,
  setShowIsNameModal,
}) => {
  const webcamRef = useRef(null);
  const [name, setName] = useState({ firstname: "", lastName: "" });
  const [image, setImage] = useState(null);
  const [showWebcam, setShowWebcam] = useState(false);
  console.log(name, "bakakdbjdbk22");

  // Capture image and start detection
  const handleCapture = () => {
    const screenshot = webcamRef.current?.getScreenshot();
    if (!screenshot) {
      alert("Unable to capture image. Try again.");
      return;
    }
    // setImage(screenshot);
    checkIfFaceExists(screenshot);
  };

  const checkIfFaceExists = async (base64Image) => {
    const buffer = base64ToBuffer(base64Image);
    const existingFace = await searchFaceByImage(buffer);

    if (existingFace?.FaceId) {
      console.log("✅ Face already enrolled:", existingFace.FaceId);
      Swal.fire({
        icon: "info",
        title: "This face is already enrolled",
        toast: true,
        showConfirmButton: false,
        timer: 4000,
      });
    } else {
      await handleSaveManually(buffer);
    }
  };

  // Convert base64 → Uint8 buffer
  function base64ToBuffer(base64String) {
    const base64Data = base64String?.split(";base64,")?.[1];
    return Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
  }

  // AWS Rekognition setup
  const rekognition = new AWS.Rekognition({
    accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
    region: process.env.REACT_APP_AWS_S3_REGION,
  });

  // Search face in collection
  const searchFaceByImage = async (imageBuffer) => {
    const params = {
      CollectionId: "Face-collection",
      FaceMatchThreshold: 90,
      Image: { Bytes: imageBuffer },
      MaxFaces: 1,
    };

    try {
      const result = await rekognition.searchFacesByImage(params).promise();
      console.log(result, "searchFaceByImage");

      if (result.FaceMatches && result.FaceMatches.length > 0) {
        return result.FaceMatches[0].Face;
      }
      return null;
    } catch (err) {
      console.error("Face search failed:", err);
      return null;
    }
  };

  // Index new face if not found
  const indexFaceFromS3Url = async (userId, imageBuffer) => {
    const params = {
      CollectionId: "Face-collection",
      DetectionAttributes: ["ALL"],
      ExternalImageId: userId,
      Image: { Bytes: imageBuffer },
    };

    return await rekognition.indexFaces(params).promise();
  };

  // Enroll new patient using Rekognition FaceId
  const handleSaveManually = async (buffer) => {
    try {
      const user_id = localStorage.getItem("user_id");

      const result = await indexFaceFromS3Url(user_id, buffer);
      const data = result?.FaceRecords?.[0]?.Face;

      if (!data?.FaceId) {
        throw new Error("Face indexing failed. No FaceId returned.");
      }

      const faceData = {
        first_name: name.firstname,
        last_name: name.lastName,
        awsFaceId: data.FaceId,
      };
      console.log(faceData, "payloadDatatata", name);

      let response = await enrollPatientByFace(faceData);

      if (typeof response === "string") {
        response = JSON.parse(response);
      }

      console.log("responseData", response);
      setPatientName(response?.data || null);

      Swal.fire({
        position: "top-end",
        icon: "success",
        title: response?.message || "Patient enrolled successfully!",
        toast: true,
        showConfirmButton: false,
        timer: 5000,
      });

      setShowIsNameModal(false);
      await handleSave(response?.data);
    } catch (err) {
      console.error("Enrollment error:", err);
      Swal.fire({
        icon: "error",
        title: "Error enrolling patient",
        text: err.message || "Something went wrong.",
      });
    }
  };

  return (
    <div className="container">
      <div className=" ">
        <div className=" mb-4">
          <p className="text-muted mb-0">
            Capture patient details and face image
          </p>
        </div>

        {!showWebcam ? (
          <button
            className="btn btn-primary w-100"
            onClick={() => setShowWebcam(true)}
          >
            Enable Face Authentication
          </button>
        ) : (
          <>
            <div className="mb-3">
              <label className="form-label">First Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter first name"
                value={name.firstname}
                onChange={(e) =>
                  setName((prev) => ({ ...prev, firstname: e.target.value }))
                }
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Last Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter last name"
                value={name.lastName}
                onChange={(e) =>
                  setName((prev) => ({ ...prev, lastName: e.target.value }))
                }
              />
            </div>
            {(!name.firstname.trim() || !name.lastName.trim()) && (
              <p className="text-danger  mt-2 font_12">
                Please enter both first and last name to enable capture.
              </p>
            )}
            {image ? (
              <div className=" mt-4">
                <img
                  src={image}
                  alt="Captured"
                  className="img-thumbnail shadow"
                  style={{ width: "430px", borderRadius: "8px" }}
                />
              </div>
            ) : (
              <div className="text-center mb-3">
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  height={200}
                  width={300}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  className=" rounded w-100"
                />
              </div>
            )}

            <button
              className="submit-btn font_18 w-100"
              onClick={handleCapture}
              disabled={!name.firstname.trim() || !name.lastName.trim()}
            >
              📸 Capture
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EnroleNewPatient;
